import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Aguardando from '../common/template/aguardando';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import ButtonTable from '../common/table/buttonTable';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { getDataHoraFormatada } from '../utils/dataUtils';
import { baixarComprovante } from '../utils/comprovanteUtils';
import {
    getLista, getDetalhe, getTipos, salvarTipo, excluirTipo,
    lancarCredito, estornarCredito, decidirDespesa, fecharMes
} from './contaCorrenteFuncionarioActions';

const agora = new Date();
const moeda = valor => `R$ ${FormatUtils.formatarValorTela(valor || 0, 2)}`;
const data = valor => valor
    ? getDataHoraFormatada(valor, 'DD/MM/YYYY') : '-';
const hoje = () => {
    const valor = new Date();
    valor.setMinutes(valor.getMinutes() - valor.getTimezoneOffset());
    return valor.toISOString().substring(0, 10);
};

const Resumo = ({ resumo }) => <div className='row'>
    {[
        ['Saldo inicial', resumo.saldo_inicial],
        ['Créditos', resumo.creditos],
        ['Despesas aprovadas', resumo.despesas_aprovadas],
        ['Saldo atual', resumo.saldo_atual],
        [`Pendentes (${resumo.quantidade_pendente || 0})`, resumo.valor_pendente]
    ].map(item => <div className='col-12 col-sm-6 col-lg' key={item[0]}>
        <div className='small text-muted'>{item[0]}</div>
        <div style={{
            fontSize: 18,
            fontWeight: 600,
            color: item[0] === 'Saldo atual' && Number(item[1]) < 0
                ? '#c0392b' : undefined
        }}>{moeda(item[1])}</div>
    </div>)}
</div>;

const ContaCorrenteFuncionario = props => {
    const [filtros, setFiltros] = useState({
        ano: agora.getFullYear(), mes: agora.getMonth() + 1, pesquisa: ''
    });
    const [selecionado, setSelecionado] = useState(null);
    const [ordenacao, setOrdenacao] = useState({
        campo: 'nome', direcao: 'asc'
    });
    const [aba, setAba] = useState('extrato');
    const [mostrarCredito, setMostrarCredito] = useState(false);
    const [credito, setCredito] = useState({
        tipo: 'DIARIA', data: hoje(), valor: '', observacao: ''
    });
    const [mostrarTipos, setMostrarTipos] = useState(false);
    const [tipo, setTipo] = useState({
        nome: '', descricao: '', exige_comprovante: true
    });
    const [fechamento, setFechamento] = useState({
        tipo_destinacao: 'TRANSPORTAR', valor_acerto: '', observacao: ''
    });

    useEffect(() => {
        props.getLista(filtros);
        props.getTipos();
    }, []);

    const parametros = id => ({
        ...filtros, id_usuario: id || selecionado
    });
    const atualizar = () => {
        props.getLista(filtros);
        if (selecionado) props.getDetalhe(parametros());
    };
    const selecionar = id => {
        setSelecionado(id);
        setAba('extrato');
        props.getDetalhe(parametros(id));
    };
    const detalhe = props.detalhe;
    const ordenar = campo => setOrdenacao(anterior => ({
        campo,
        direcao: anterior.campo === campo && anterior.direcao === 'asc'
            ? 'desc' : 'asc'
    }));
    const listaOrdenada = [...props.lista].sort((a, b) => {
        const primeiro = a[ordenacao.campo];
        const segundo = b[ordenacao.campo];
        const comparacao = ordenacao.campo === 'nome'
            ? String(primeiro || '').localeCompare(String(segundo || ''))
            : Number(primeiro || 0) - Number(segundo || 0);
        return ordenacao.direcao === 'asc' ? comparacao : -comparacao;
    });

    const confirmarCredito = async evento => {
        evento.preventDefault();
        await props.lancarCredito({
            ...credito, id_usuario: selecionado
        }, parametros());
        setMostrarCredito(false);
        setCredito({ tipo: 'DIARIA', data: hoje(), valor: '', observacao: '' });
    };

    const decidir = (despesa, status) => {
        let justificativa = null;
        if (status === 'REPROVADA') {
            justificativa = window.prompt('Justificativa da reprovação:');
            if (!justificativa) return;
        } else if (!window.confirm('Aprovar esta despesa?')) return;
        props.decidirDespesa({
            id: despesa.id, status, justificativa
        }, parametros());
    };

    const confirmarFechamento = async evento => {
        evento.preventDefault();
        await props.fecharMes({
            ...fechamento,
            id_usuario: selecionado,
            ano: filtros.ano,
            mes: filtros.mes
        }, parametros());
    };

    return <Content>
        <Aguardando aguardando={props.aguardando} />
        <ContentCard>
            <ContentCardHeader>
                <div className='row align-items-end'>
                    <div className='col-6 col-md-2 form-group mb-0'>
                        <label>Mês</label>
                        <select className='form-control' value={filtros.mes}
                            onChange={e => setFiltros({
                                ...filtros, mes: Number(e.target.value)
                            })}>
                            {Array.from({ length: 12 }, (_, i) =>
                                <option value={i + 1} key={i + 1}>{i + 1}</option>)}
                        </select>
                    </div>
                    <div className='col-6 col-md-2 form-group mb-0'>
                        <label>Ano</label>
                        <input className='form-control' type='number'
                            value={filtros.ano}
                            onChange={e => setFiltros({
                                ...filtros, ano: Number(e.target.value)
                            })} />
                    </div>
                    <div className='col-12 col-md-4 form-group mb-0'>
                        <label>Funcionário</label>
                        <input className='form-control' value={filtros.pesquisa}
                            placeholder='Pesquisar pelo nome'
                            onChange={e => setFiltros({
                                ...filtros, pesquisa: e.target.value
                            })}
                            onKeyDown={e => e.key === 'Enter' && atualizar()} />
                    </div>
                    <div className='col-12 col-md-4 mt-2 mt-md-0'>
                        <button className='btn btn-primary' onClick={atualizar}>
                            <i className='fas fa-sync-alt' /> Atualizar
                        </button>{' '}
                        <button className='btn btn-secondary'
                            onClick={() => setMostrarTipos(!mostrarTipos)}>
                            Tipos de despesa
                        </button>
                    </div>
                </div>
            </ContentCardHeader>
            <ContentCardBody>
                {mostrarTipos && <div className='card card-outline card-secondary'>
                    <div className='card-body'>
                        <h5>Tipos de despesa</h5>
                        <form onSubmit={async e => {
                            e.preventDefault();
                            await props.salvarTipo(tipo);
                            setTipo({ nome: '', descricao: '', exige_comprovante: true });
                        }} className='row align-items-end'>
                            <div className='col-md-3 form-group'>
                                <label>Nome *</label>
                                <input className='form-control' required value={tipo.nome}
                                    onChange={e => setTipo({ ...tipo, nome: e.target.value })} />
                            </div>
                            <div className='col-md-5 form-group'>
                                <label>Descrição</label>
                                <input className='form-control' value={tipo.descricao || ''}
                                    onChange={e => setTipo({ ...tipo, descricao: e.target.value })} />
                            </div>
                            <div className='col-md-2 form-group'>
                                <label><input type='checkbox'
                                    checked={tipo.exige_comprovante}
                                    onChange={e => setTipo({
                                        ...tipo, exige_comprovante: e.target.checked
                                    })} /> Exige comprovante</label>
                            </div>
                            <div className='col-md-2 form-group'>
                                <button className='btn btn-success' type='submit'>Salvar</button>{' '}
                                {tipo.id && <button className='btn btn-light' type='button'
                                    onClick={() => setTipo({
                                        nome: '', descricao: '', exige_comprovante: true
                                    })}>Cancelar</button>}
                            </div>
                        </form>
                        <table className='table table-sm table-hover'>
                            <tbody>{props.tipos.map(item => <tr key={item.id}>
                                <td>{item.nome}</td><td>{item.descricao}</td>
                                <td>{item.exige_comprovante ? 'Sim' : 'Não'}</td>
                                <td className='text-right'>
                                    <ButtonTable
                                        visible
                                        small
                                        type='warning'
                                        icon='fas fa-pencil-alt'
                                        title='Editar'
                                        event={() => setTipo(item)}
                                    />
                                    {!item.codigo && <ButtonTable
                                        visible
                                        small
                                        type='danger'
                                        icon='fas fa-trash-alt'
                                        title='Excluir'
                                        event={() =>
                                            window.confirm('Excluir este tipo?') &&
                                            props.excluirTipo(item.id)}
                                    />}
                                </td>
                            </tr>)}</tbody>
                        </table>
                    </div>
                </div>}

                <div className='table-responsive'>
                    <table className='table table-hover table-sm table-bordered'>
                        <thead><tr>
                            <th onClick={() => ordenar('nome')} style={{ cursor: 'pointer' }}>Funcionário</th>
                            <th onClick={() => ordenar('saldo_inicial')} style={{ cursor: 'pointer' }} className='text-right'>Saldo inicial</th>
                            <th onClick={() => ordenar('creditos')} style={{ cursor: 'pointer' }} className='text-right'>Créditos</th>
                            <th onClick={() => ordenar('despesas_aprovadas')} style={{ cursor: 'pointer' }} className='text-right'>Despesas aprovadas</th>
                            <th onClick={() => ordenar('quantidade_pendente')} style={{ cursor: 'pointer' }} className='text-center'>Pendentes</th>
                            <th onClick={() => ordenar('saldo_atual')} style={{ cursor: 'pointer' }} className='text-right'>Saldo atual</th>
                            <th className='text-center'>Acerto</th>
                        </tr></thead>
                        <tbody>{listaOrdenada.map(item => <tr key={item.id}
                            onClick={() => selecionar(item.id)}
                            style={{ cursor: 'pointer' }}
                            className={Number(selecionado) === Number(item.id)
                                ? 'table-primary' : ''}>
                            <td>{item.nome}</td>
                            <td className='text-right'>{moeda(item.saldo_inicial)}</td>
                            <td className='text-right'>{moeda(item.creditos)}</td>
                            <td className='text-right'>{moeda(item.despesas_aprovadas)}</td>
                            <td className='text-center'>{item.quantidade_pendente} ({moeda(item.valor_pendente)})</td>
                            <td className='text-right'>{moeda(item.saldo_atual)}</td>
                            <td className='text-center'>{item.situacao_fechamento}</td>
                        </tr>)}</tbody>
                    </table>
                </div>
            </ContentCardBody>
        </ContentCard>

        {detalhe && Number(detalhe.resumo.id) === Number(selecionado) &&
            <ContentCard>
                <ContentCardHeader>
                    <div className='d-flex justify-content-between align-items-center'>
                        <h5 className='mb-0'>{detalhe.resumo.nome}</h5>
                        <button className='btn btn-success btn-sm'
                            onClick={() => setMostrarCredito(!mostrarCredito)}>
                            <i className='fas fa-plus' /> Lançar crédito
                        </button>
                    </div>
                </ContentCardHeader>
                <ContentCardBody>
                    <Resumo resumo={detalhe.resumo} />
                    {mostrarCredito && <form onSubmit={confirmarCredito}
                        className='row align-items-end mt-3 p-2 bg-light'>
                        <div className='col-md-2 form-group'>
                            <label>Tipo</label><select className='form-control'
                                value={credito.tipo} onChange={e => setCredito({
                                    ...credito, tipo: e.target.value
                                })}>
                                <option value='DIARIA'>Diária</option>
                                <option value='ADIANTAMENTO'>Adiantamento mensal</option>
                            </select>
                        </div>
                        <div className='col-md-2 form-group'><label>Data</label>
                            <input required type='date' className='form-control'
                                value={credito.data} onChange={e => setCredito({
                                    ...credito, data: e.target.value
                                })} /></div>
                        <LabelAndInputNumber
                            name='valor_credito'
                            label='Valor *'
                            cols='12 12 2 2'
                            casas={2}
                            value={credito.valor}
                            onChange={e => setCredito({
                                ...credito,
                                valor: e.target.value
                            })}
                        />
                        <div className='col-md-4 form-group'><label>Observação</label>
                            <input className='form-control' value={credito.observacao}
                                onChange={e => setCredito({ ...credito, observacao: e.target.value })} /></div>
                        <div className='col-md-2 form-group'><button className='btn btn-success'>Confirmar</button></div>
                    </form>}
                    <ul className='nav nav-tabs mt-3'>
                        {[
                            ['extrato', 'Extrato'], ['despesas', 'Despesas'],
                            ['acerto', 'Acerto mensal'], ['historico', 'Fechamentos']
                        ].map(item => <li className='nav-item' key={item[0]}>
                            <button className={`nav-link ${aba === item[0] ? 'active' : ''}`}
                                onClick={() => setAba(item[0])}>{item[1]}</button>
                        </li>)}
                    </ul>
                    {aba === 'extrato' && <div className='table-responsive mt-2'>
                        <table className='table table-sm table-striped'><thead><tr>
                            <th>Data</th><th>Descrição</th><th className='text-right'>Crédito</th>
                            <th className='text-right'>Débito</th><th className='text-right'>Saldo</th><th />
                        </tr></thead><tbody>{detalhe.extrato.map(item => <tr key={item.id}>
                            <td>{data(item.data)}</td><td>{item.descricao}</td>
                            <td className='text-right'>{item.natureza === 'CREDITO' ? moeda(item.valor) : '-'}</td>
                            <td className='text-right'>{item.natureza === 'DEBITO' ? moeda(item.valor) : '-'}</td>
                            <td className='text-right'>{moeda(item.saldo_acumulado)}</td>
                            <td>{item.natureza === 'CREDITO' &&
                                ['DIARIA', 'ADIANTAMENTO'].includes(item.tipo) &&
                                <ButtonTable
                                    visible
                                    small
                                    type='danger'
                                    icon='fas fa-undo-alt'
                                    title='Estornar crédito'
                                    event={() =>
                                        window.confirm('Estornar este crédito?') &&
                                        props.estornarCredito({
                                            id: item.id,
                                            id_usuario: selecionado
                                        }, parametros())}
                                />}</td>
                        </tr>)}</tbody></table>
                    </div>}
                    {aba === 'despesas' && <div className='table-responsive mt-2'>
                        <table className='table table-sm table-striped'><thead><tr>
                            <th>Data</th><th>Tipo</th><th>Descrição</th><th className='text-right'>Valor</th>
                            <th>Status</th><th>Comprovante</th><th>Ações</th>
                        </tr></thead><tbody>{detalhe.despesas.map(item => <tr key={item.id}>
                            <td>{data(item.data)}</td><td>{item.nome_tipo_despesa}</td>
                            <td>{item.descricao}</td><td className='text-right'>{moeda(item.valor)}</td>
                            <td>{item.status}</td><td>{item.comprovante
                                ? <ButtonTable
                                    visible
                                    small
                                    type='info'
                                    icon='fas fa-download'
                                    title='Baixar comprovante'
                                    event={() => baixarComprovante(
                                        item.comprovante,
                                        item.comprovante_nome,
                                        item.comprovante_tipo
                                    )}
                                /> : '-'}</td>
                            <td>{item.status === 'PENDENTE' && <React.Fragment>
                                <ButtonTable visible small type='success'
                                    icon='fas fa-check' title='Aprovar'
                                    event={() => decidir(item, 'APROVADA')} />
                                <ButtonTable visible small type='danger'
                                    icon='fas fa-times' title='Reprovar'
                                    event={() => decidir(item, 'REPROVADA')} />
                            </React.Fragment>}</td>
                        </tr>)}</tbody></table>
                    </div>}
                    {aba === 'acerto' && <form onSubmit={confirmarFechamento} className='row mt-3'>
                        <div className='col-md-4 form-group'><label>Destinação do saldo</label>
                            <select className='form-control' value={fechamento.tipo_destinacao}
                                onChange={e => setFechamento({
                                    ...fechamento, tipo_destinacao: e.target.value
                                })}>
                                <option value='TRANSPORTAR'>Transportar saldo</option>
                                <option value='DEVOLUCAO'>Devolução à empresa</option>
                                <option value='REEMBOLSO'>Complemento/reembolso</option>
                                <option value='SALDO_ZERO'>Saldo zero</option>
                            </select></div>
                        <LabelAndInputNumber
                            name='valor_acerto'
                            label='Valor do acerto'
                            cols='12 12 3 3'
                            casas={2}
                            readOnly={[
                                'TRANSPORTAR',
                                'SALDO_ZERO'
                            ].includes(fechamento.tipo_destinacao)}
                            value={fechamento.valor_acerto}
                            onChange={e => setFechamento({
                                ...fechamento,
                                valor_acerto: e.target.value
                            })}
                        />
                        <div className='col-md-3 form-group'><label>Observação</label>
                            <input className='form-control' value={fechamento.observacao}
                                onChange={e => setFechamento({ ...fechamento, observacao: e.target.value })} /></div>
                        <div className='col-md-2 form-group align-self-end'>
                            <button className='btn btn-primary' disabled={
                                Number(detalhe.resumo.quantidade_pendente) > 0 ||
                                detalhe.resumo.situacao_fechamento === 'FECHADO'
                            }>Confirmar fechamento</button>
                        </div>
                        {Number(detalhe.resumo.quantidade_pendente) > 0 &&
                            <div className='col-12 alert alert-warning'>Resolva as despesas pendentes antes do fechamento.</div>}
                    </form>}
                    {aba === 'historico' && <table className='table table-sm mt-2'>
                        <thead><tr><th>Competência</th><th>Destinação</th><th className='text-right'>Saldo final</th><th>Responsável</th></tr></thead>
                        <tbody>{detalhe.fechamentos.map(item => <tr key={item.id}>
                            <td>{String(item.mes).padStart(2, '0')}/{item.ano}</td>
                            <td>{item.tipo_destinacao}</td><td className='text-right'>{moeda(item.saldo_final)}</td>
                            <td>{item.nome_usuario_inclusao}</td>
                        </tr>)}</tbody>
                    </table>}
                </ContentCardBody>
            </ContentCard>}
    </Content>;
};

const mapState = state => ({ ...state.contaCorrenteFuncionario });
const actions = {
    getLista, getDetalhe, getTipos, salvarTipo, excluirTipo,
    lancarCredito, estornarCredito, decidirDespesa, fecharMes
};
export default connect(
    mapState,
    dispatch => bindActionCreators(actions, dispatch)
)(ContaCorrenteFuncionario);
